/*
import Vue from 'vue'

if (document.cookie.match(new RegExp(`XSRF-TOKEN=([^;]+)`))) {
  const csrftoken = document.cookie.match(new RegExp(`XSRF-TOKEN=([^;]+)`))[1]
  Vue.$axios.headers.common['X-CSRF-TOKEN'] = csrftoken
}
*/
export default function({ $axios, app }) {
  window.$axios = $axios
  $axios.onRequest(config => {
    if (!config.no_loading) {
      window._eventHub.$emit('onBeginRequest')
    }
    if (app.$i18n.locale && app.$i18n.locale.length > 2) {
      config.headers['accept-language'] = app.$i18n.locale.substring(0, 2)
    }
    config.headers['Cache-Control'] = 'no-cache'
    config.headers['X-Locale'] = app.$i18n.locale
    config.headers['X-Site-ID'] = process.env.siteId
    config.headers['X-Front-Domain'] =
      location.protocol + '//' + document.location.host
  })
  $axios.onResponse(async response => {
    if (response.status === 266 && app.$auth.getRefreshToken('jwt')) {
      if (response.config.url.endsWith('auth/public/refreshToken')) {
        app.$auth.setToken('jwt', false)
        app.$auth.setRefreshToken('jwt', false)
        app.$auth.strategies.jwt._setToken(false)
        app.$auth.strategies.jwt._setRefreshToken(false)
        window._eventHub.$emit('onSessionExpired', { toast: true })

        if (!response.config.no_loading) {
          window._eventHub.$emit('onEndRequest', response.config)
        }
        return response
      }
      const originalRequest = response.config

      const endpoint = {
        headers: {
          Authorization: app.$auth.getRefreshToken('jwt')
        }
      }

      const result = await app.$auth.strategies.jwt.$auth.request(
        endpoint,
        app.$auth.strategies.jwt.options.endpoints.refresh
      )

      if (!result || !result.token) {
        app.$auth.setToken('jwt', false)
        app.$auth.setRefreshToken('jwt', false)
        app.$auth.strategies.jwt._setToken(false)
        app.$auth.strategies.jwt._setRefreshToken(false)
        window._eventHub.$emit('onSessionExpired', { toast: true })

        if (!response.config.no_loading) {
          window._eventHub.$emit('onEndRequest', response.config)
        }
        return response
      }

      if (app.$auth.strategies.jwt.options.tokenRequired) {
        const token = app.$auth.strategies.jwt.options.tokenType
          ? app.$auth.strategies.jwt.options.tokenType + ' ' + result.token
          : result.token

        const refreshToken = app.$auth.strategies.jwt.options.tokenType
          ? app.$auth.strategies.jwt.options.tokenType +
            ' ' +
            result.refreshToken
          : result.refreshToken

        app.$auth.strategies.jwt.$auth.setToken('jwt', token)
        app.$auth.strategies.jwt.$auth.setRefreshToken('jwt', refreshToken)
        app.$auth.strategies.jwt._setToken(token)
        app.$auth.strategies.jwt._setRefreshToken(refreshToken)
        originalRequest.headers.Authorization = token

        if (!response.config.no_loading) {
          window._eventHub.$emit('onEndRequest', response.config)
        }
        return $axios(originalRequest)
      }
    }
    if (!response.config.no_loading) {
      window._eventHub.$emit('onEndRequest', response.config)
    }
    return response
  })

  $axios.onError(error => {
    if (
      error &&
      error.response &&
      error.response.status >= 400 &&
      (!error.response.config ||
        !error.response.config.url ||
        error.response.config.url.endsWith('auth/public/refreshToken'))
    ) {
      app.$auth.setToken('jwt', false)
      app.$auth.setRefreshToken('jwt', false)
      app.$auth.strategies.jwt._setToken(false)
      app.$auth.strategies.jwt._setRefreshToken(false)
      window._eventHub.$emit('onSessionExpired', { toast: true })
    } else if (error && error.response && error.response.status === 401) {
      app.$auth.setToken('jwt', false)
      app.$auth.setRefreshToken('jwt', false)
      app.$auth.strategies.jwt._setToken(false)
      app.$auth.strategies.jwt._setRefreshToken(false)
    }
    if (error.response) {
      let skip = false
      if (
        error.response.config &&
        error.response.config.url &&
        error.response.data &&
        error.response.data.resultCode &&
        ((error.response.config.url.endsWith('auth/public/signIn') &&
          (error.response.data.resultCode === 'no_such_user_login' ||
            error.response.data.resultCode === 'inactive' ||
            error.response.data.resultCode === 'waiting' ||
            error.response.data.resultCode === 'sleeping' ||
            error.response.data.resultCode === 'expired' ||
            error.response.data.resultCode.startsWith('password_expired_'))) ||
          ((error.response.config.url.endsWith('auth/public/findPassword') &&
            error.response.data.resultCode === 'choose_name_for_same_id') ||
            error.response.data.resultCode === 'no_such_user_login') ||
          error.response.data.resultCode === 'no_such_sponser' ||
          error.response.data.resultCode === 'choose_name_for_same_id' ||
          error.response.config.url.indexOf('savePlayHist') >= 0 ||
          error.response.config.url.indexOf('public/error') >= 0)
      ) {
        skip = true
      }
      if (
        error.response.config &&
        error.response.config.ignoreResultCodes &&
        error.response.data &&
        error.response.data.resultCode
      ) {
        for (const resultCode in error.response.config.ignoreResultCodes) {
          if (error.response.data.resultCode === resultCode) {
            skip = true
            break
          }
        }
      }
      if (
        error.response.data &&
        (error.response.data.resultCode === 'exceed_device_count' ||
          error.response.data.resultCode === 'forbidden')
      ) {
        skip = true
      }
      if (!skip) {
        console.error(error.response)
      }
      if (
        error.response.data &&
        error.response.data.message &&
        error.response.data.resultCode !== 'choose_name_for_same_id' &&
        (!error.response.config ||
          !error.response.config.url ||
          (error.response.config.url.indexOf('savePlayHist') < 0 &&
            error.response.config.url.indexOf('public/error') < 0))
      ) {
        app.$toast.error(
          app.$i18n.$t(error.response.data.message, error.response.data.params)
        )
      }
    } else {
      console.error(error)
    }
    if (
      !error.response ||
      !error.response.config ||
      !error.response.config.no_loading
    ) {
      window._eventHub.$emit(
        'onEndRequest',
        error && error.response ? error.response.config : undefined
      )
    }
  })
}
